import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
var AddLoanComponent = /** @class */ (function () {
    function AddLoanComponent(headerService, copyService, fb, parametersService, navigationService, abreCuentasService, helperService, bitacoraService) {
        this.headerService = headerService;
        this.copyService = copyService;
        this.fb = fb;
        this.parametersService = parametersService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.helperService = helperService;
        this.bitacoraService = bitacoraService;
        this.idForm = 0;
        this.showAdd = true;
        this.headerService.show(true, true, true);
        this.bankList = this.parametersService.getSetting(OpEnum.LOAN_BANK_LIST);
    }
    AddLoanComponent.prototype.ngOnInit = function () {
        var _this = this;
        var formData = this.abreCuentasService.getFormLoan();
        this.abreCuentasService.setDidBackAddLoan(false);
        if (formData) {
            this.formData = this.fb.group({
                addLoanForm: this.fb.array([]),
            });
            formData.addLoanForm.map(function (form) {
                var addLoanForm = _this.fb.group({
                    valuePortfolioForm: [form.valuePortfolioForm, Validators.required],
                    entityLoanForm: [form.entityLoanForm, Validators.required],
                    freeValueForm: [form.freeValueForm, Validators.required],
                    numProductForm: [form.numProductForm, Validators.required],
                    nameEntityForm: [form.nameEntityForm],
                    nitEntityForm: [form.nitEntityForm],
                    idForm: [form.idForm],
                    show: [form.show],
                });
                _this.idForm = form.idForm;
                _this.addLoanForm.push(addLoanForm);
            });
        }
        else {
            this.formData = this.fb.group({
                addLoanForm: this.fb.array([]),
            });
            this.addLoan();
        }
    };
    Object.defineProperty(AddLoanComponent.prototype, "addLoanForm", {
        get: function () {
            return this.formData.controls['addLoanForm'];
        },
        enumerable: true,
        configurable: true
    });
    AddLoanComponent.prototype.addLoan = function () {
        if (this.addLoanForm.length >= 15) {
            this.showAdd = false;
        }
        if (this.addLoanForm.length < 15) {
            var addLoanForm = this.fb.group({
                valuePortfolioForm: ['', Validators.required],
                entityLoanForm: ['', Validators.required],
                freeValueForm: ['', Validators.required],
                numProductForm: ['', Validators.required],
                nameEntityForm: [''],
                nitEntityForm: [''],
                idForm: [this.idForm],
                show: [false],
            });
            this.addLoanForm.push(addLoanForm);
            this.idForm++;
        }
    };
    AddLoanComponent.prototype.alphaNumberOnly = function (event) {
        var keyCode;
        keyCode = event.keyCode;
        if (event.target.value.length < 10) {
            return this.isNumber(keyCode);
        }
        else {
            return false;
        }
    };
    AddLoanComponent.prototype.isNumber = function (keyCode) {
        return (keyCode >= 48 && keyCode <= 57);
    };
    AddLoanComponent.prototype.updateValue = function (event, form) {
        var newvalue = this.helperService.currency(event.target.value);
        this.formData.controls["" + form].setValue(newvalue.clearValue);
        event.target.value = newvalue.format;
    };
    AddLoanComponent.prototype.updateValueForm = function (index, form, event) {
        index = parseInt(index, 10);
        var value = this.helperService.currency(this.addLoanForm.value[index]["" + form]);
        // @ts-ignore
        this.addLoanForm.at(index).get("" + form).setValue(value.clearValue);
        // this.addLoanForm[index].controls[`${form}`].setValue(value.clearValue);
        event.target.value = value.format;
    };
    AddLoanComponent.prototype.showNitName = function (index) {
        // @ts-ignore
        return this.addLoanForm.value[index]['show'];
    };
    AddLoanComponent.prototype.selectOther = function (nit, index) {
        this.formEntity = nit;
        if (this.formEntity && this.formEntity.nit === '0' && index === this.addLoanForm.value[index]['idForm']) {
            // @ts-ignore
            this.addLoanForm.at(index).get('nitEntityForm').setValidators([Validators.required]);
            // @ts-ignore
            this.addLoanForm.at(index).get('nameEntityForm').setValidators([Validators.required]);
            // @ts-ignore
            this.addLoanForm.at(index).get('show').setValue(true);
        }
        else {
            // @ts-ignore
            this.addLoanForm.at(index).get('show').setValue(false);
            // @ts-ignore
            this.addLoanForm.at(index).get('nameEntityForm').setValue(nit.name);
            // @ts-ignore
            this.addLoanForm.at(index).get('nitEntityForm').setValue(nit.nit);
        }
    };
    AddLoanComponent.prototype.back = function () {
        this.abreCuentasService.setDidBackAddLoan(true);
    };
    AddLoanComponent.prototype.next = function () {
        var _this = this;
        this.abreCuentasService.setFormLoan(this.formData.value);
        var formData = this.abreCuentasService.getFormLoan();
        formData.addLoanForm.map(function (i) {
            var mark = "purchase_" + i.valuePortfolioForm + " Entity_purchase_" + i.entityLoanForm + " creditfee_" + i.freeValueForm + " reference_" + i.numProductForm;
            _this.bitacoraService.saveDataInBitacora(mark);
        });
        var disbursed_method = this.abreCuentasService.getAgreementDetailSelected().disbursed_method;
        if (disbursed_method === '01' || disbursed_method === '03') {
            this.abreCuentasService.setOutlaySelection(BUSINESS_CONST.CHEQUE);
            this.navigationService.nextStep('201');
        }
        else {
            this.navigationService.nextStep('200');
        }
    };
    return AddLoanComponent;
}());
export { AddLoanComponent };
